export default "__VITE_ASSET__pneBuBdD__"